
import { useState, useEffect } from "react";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setShowBanner(true);
    } else if (consent === "true") {
      enableAnalytics();
    }
  }, []);

  const enableAnalytics = () => {
    // Initialize GA if not already loaded
    if (typeof window.gtag !== "function") {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
    }

    // Update consent status and config
    window.gtag("consent", "update", {
      analytics_storage: "granted",
    });

    window.gtag("js", new Date());
    window.gtag("config", "G-7DYX3TDMZ1");
  };

  const disableAnalytics = () => {
    window.gtag?.("consent", "update", {
      analytics_storage: "denied",
    });
  };

  const acceptCookies = () => {
    localStorage.setItem("cookie_consent", "true");
    enableAnalytics();
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookie_consent", "false");
    disableAnalytics();
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        background: "black",
        color: "white",
        padding: "4px 8px",
        textAlign: "center",
        zIndex: 9999,
        boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
        borderTop: "1px solid rgba(255,255,255,0.1)",
 
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "10px",
          background: "transparent",
          padding: "4px 10px",
          borderRadius: "8px",
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "1.4",
            flex: "1",
            minWidth: "250px",
            textAlign: "left",
            
          }}
        >
          We use cookies for analytics to improve your experience. Do you accept?
        </p>

        <div
          style={{
            display: "flex",
            gap: "8px",
            alignItems: "center",
          }}
        >
          <button
            onClick={rejectCookies}
            style={{
              padding: "6px 14px",
              background: "transparent",
              border: "1px solid rgba(255,255,255,0.3)",
              color: "white",
              borderRadius: "20px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: "500",
              transition: "all 0.3s ease",
              minWidth: "70px",
            }}
          >
            Reject
          </button>

          <button
            onClick={acceptCookies}
            style={{
              padding: "6px 16px",
              background: "rgba(255,255,255,0.9)",
              border: "none",
              color: "#333",
              borderRadius: "20px",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: "600",
              transition: "all 0.3s ease",
              minWidth: "70px",
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
